/**
 * Section intro component
 * 
 */

import React, { PureComponent } from 'react';

// Components

import Image from '../image/image';

export default class SectionIntro extends PureComponent {

	render() {
		
		const { data } = this.props;
		
		if (data.background && data.background.url) {

			return (

				<div className="section section-catchline section-background text-center">
					<div className="section-content container">

						{ !! data.title && <h1>{data.title}</h1> }

					</div>
					<div className="section-graphic">

						<div className="section-cover"><Image data={data.background}/></div>

					</div>
				</div>
			)
		}
		else {

			return (

				<div className="section section-catchline text-center">
					<div className="container">

						{ !! data.title && <h1>{data.title}</h1> }

					</div>
				</div>
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/sections/section-intro.js